// extracted by mini-css-extract-plugin
module.exports = {"container":"Whatsapp_container__qgkww","iconWrapper":"Whatsapp_iconWrapper__1LDsn","icon":"Whatsapp_icon__IsBGM"};